// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.static_pages.contact").length) return;
  // お問い合わせされる前に該当するFAQ記事を見せる
  $(() => {
    // jQuery-uiがバグってて読み込めないのでここで読み込んでいる
    const jquery_ui = document.createElement("script");
    jquery_ui.src = "https://code.jquery.com/ui/1.12.1/jquery-ui.js";
    document.body.appendChild(jquery_ui);

    $.get(
      "https://activo.zendesk.com/api/v2/help_center/ja/articles.js?per_page=50"
    ).done((data) => {
      const articles = $.map(data.articles, (article, _i) => ({
        title: article.title,
        value: article.title,
        url: article.html_url,
      }));

      $(".suggestFaqList")
        .autocomplete({
          minLength: 2,
          source: articles,
          select(event, ui) {
            window.open(ui.item.url);
            return false;
          },
        })
        .autocomplete("instance")._renderItem = function (ul, item) {
        return $(ul).append(
          `<li><a class="suggestFaqList" href="${item.url}" target="_blank">${item.title}</a></li>`
        );
      };

      $(".subjectSuggestFaq")
        .autocomplete({
          minLength: 2,
          source: articles,
          response(_event, _ui) {
            $(".subjectSuggestFaqList").empty();
            $("ul.subjectSuggestFaqList").before(
              '<div class="subjectSuggestFaqList">関連する質問</div>'
            );
            $("div.subjectSuggestFaqList").css({
              margin: "10px 0",
            });
          },
        })
        .autocomplete("instance")._renderItem = function (ul, item) {
        ul.remove();
        return $("ul.subjectSuggestFaqList").append(
          `<li><a class="subjectSuggestFaqList" href="${item.url}" target="_blank">${item.title}</a></li>`
        );
      };
    });
  });

  changeFormsByUserStatusChoice();
  changeFormsByContactKindChoice();
});

$(() => {
  if (!$("body.static_pages.for_company_volunteer").length) return;
  seeMoreVolunteers();
});

$(() => {
  if (!$("body.pc.static_pages.for_company_volunteer").length) return;
  forCompanyVolNavigate(".h2_link");
  forCompanyVolNavigate(".h3_link");
  $(window).on("load", () => {
    const contentHeight = $(
      ".l_mainContent.isWide.isTransparent.isWideInside"
    ).height();
    $(".l_sideContent.isTransparent.isWideInside.isWide").height(contentHeight);
  });
});

function changeFormsByUserStatusChoice() {
  // 利用者の属性に応じて表示するフォームの種類を変更
  $("#jsICKField").hide();
  // 属性が団体のときのみ団体名カラムを表示
  $(".jsGroupName").hide();
  // 属性が変わったとき、スクショ欄は消す
  $("#jsScreenShot").hide();
  $("#jsUserStatus").change(function () {
    const val = $(this).val();
    $(".jsGroupName").hide();
    $(".jsHelpTextRecommendingFormat").hide();
    $("#jsContactKindField").show();
    switch (val) {
      case "activoをご利用中の団体の方":
        $("#jsGCKField").show();
        $("#jsGroupContactKind").attr("disabled", false);
        $("#jsICKField").hide();
        $("#jsIndividualContactKind").attr("disabled", true);
        $(".jsGroupName").show();
        break;

      case "activoをご利用中の個人の方":
        $("#jsICKField").show();
        $("#jsIndividualContactKind").attr("disabled", false);
        $("#jsGCKField").hide();
        $("#jsGroupContactKind").attr("disabled", true);
        $(".jsHelpLinkForCancel").hide();
        break;

      case "その他":
        // その他の場合は、Kindカラム自体表示しない
        $("#jsContactKindField").hide();
        $("#jsGroupContactKind").attr("disabled", true);
        $("#jsIndividualContactKind").attr("disabled", true);
        break;
    }
  });
}

function changeFormsByContactKindChoice() {
  // 各ボランティアに関する問い合わせが来ないように
  $(".jsSubmit.isInCorrect").hide();
  // エラーの際にはスクリーンショットを添付できるように
  $("#jsScreenShot").hide();
  // エラーを選択したときのみ詳細情報の推奨文を表示
  $(".jsHelpTextRecommendingFormat").hide();
  $("#jsGroupContactKind, #jsIndividualContactKind").change(function () {
    const val = $(this).val();
    $(".jsSubmit.isCorrect").show();
    $(".jsSubmit.isInCorrect").hide();
    $("#jsScreenShot").hide();
    // kindが[退会について」のときのみ、退会のヘルプリンクを表示
    $(".jsHelpLinkForCancel").hide();
    $(".jsHelpTextRecommendingFormat").hide();
    switch (val) {
      case "各ボランティアに関するご質問":
        $(".jsSubmit.isInCorrect").show();
        $(".jsSubmit.isCorrect").hide();
        break;

      case "エラー・不具合の発生":
        $("#jsScreenShot").show();
        $(".jsHelpTextRecommendingFormat").show();
        break;

      case "退会について":
        $(".jsHelpLinkForCancel").show();
        break;
    }
  });
}

function seeMoreVolunteers() {
  const articleList = $(".m_mainArticleList").children(".resultBox");
  articleList.each(function (i, _e) {
    if (i > 9) {
      $(this).hide();
    }
  });
  $("body.static_pages.for_company_volunteer").on("click", "p.seeMore", (e) => {
    $(e.target).remove();
    $.when(
      articleList.each(function () {
        $(this).show();
      })
    ).done(() => {
      const contentHeight = $(
        ".l_mainContent.isWide.isTransparent.isWideInside"
      ).height();
      $(".l_sideContent.isTransparent.isWideInside.isWide").height(
        contentHeight
      );
    });
  });
}

function forCompanyVolNavigate(linkSelector) {
  const tocLink = $(linkSelector);
  // 見出しを配列に格納
  const contentsArr = [];
  for (let i = 0; i < tocLink.length; i += 1) {
    // 見出しを取得
    const targetContents = $(tocLink.eq(i).attr("href"));
    // 配列に格納
    contentsArr[i] = targetContents;
  }
  // ページ読み込み時とスクロール時に、現在地をチェックする
  $(window).on("load scroll", () => {
    tocLink.removeClass("current");
    // 現在のスクロール位置を取得
    const windowScrolltop = $(window).scrollTop() + 64;
    for (let i = 0; i < contentsArr.length; i += 1) {
      // 現在のスクロール位置が、見出しと次の見出しの間にあるものを調べる
      if (i < contentsArr.length - 1) {
        var isCorrectNavigation =
          contentsArr[i].offset().top <= windowScrolltop &&
          contentsArr[i + 1].offset().top > windowScrolltop;
      } else if (i === contentsArr.length - 1) {
        var isCorrectNavigation =
          contentsArr[i].offset().top <= windowScrolltop;
      }
      const isNextLinkNotCurrent = !tocLink
        .eq(i)
        .parent()
        .parents("li")
        .next()
        .children(".h2_link")
        .hasClass("current");
      if (isCorrectNavigation && isNextLinkNotCurrent) {
        // ナビゲーションにclass="current"をつける
        tocLink.eq(i).addClass("current");
      }
    }
  });
}
